import { STYLES } from "../constants";

export const isMob = window.matchMedia(`(max-width: ${STYLES.screen.sm})`)
  .matches;
